export default __webpack_public_path__ + "static/media/share.3060249e.svg";